import React from 'react';
import { Text } from '../../../globalStyles';
import { EditHandbookInput } from '../EditHandbookInput';
import { SectionRow, SectionRowItem } from './SectionRow';
import type { EdibleSectionProps, EditableSectionRowInfo, HandBookInfo } from './types';
import { EditOrganizationHandbookInput } from '../../../graphQL';

type Props = EdibleSectionProps & {
  handbookInfo: HandBookInfo;
  editableSectionRowInfo: EditableSectionRowInfo[];
  submitFunction: (
    editFieldName: keyof EditOrganizationHandbookInput
  ) => (value: string) => Promise<void>;
  verticalDisplay?: boolean;
};

export const titleAccommodations = 'Accommodations, ADHD, & Medical Leave';

export function AccommodationsSection({
  handbookInfo,
  selectedField,
  editableSectionRowInfo,
  verticalDisplay,
  onCancelEdit,
  onSave,
  onStartEdit,
}: Props) {
  return (
    <>
      {editableSectionRowInfo.map(row => (
        <SectionRow verticalDisplay={verticalDisplay} label={row.label} info={row.info}>
          <SectionRowItem onEditClick={onStartEdit ? () => onStartEdit(row.displayKey) : undefined}>
            {selectedField === row.displayKey ? (
              <EditHandbookInput
                handbookRowInfo={String(handbookInfo[row.displayKey])}
                selectedField={row.displayKey}
                onCancel={onCancelEdit}
                onSave={onSave ? value => onSave(row.editInputKey, value) : undefined}
              />
            ) : (
              <Text.bodySmall>{handbookInfo[row.displayKey]}</Text.bodySmall>
            )}
          </SectionRowItem>
        </SectionRow>
      ))}
    </>
  );
}
